import React, { ReactNode, useState } from "react";
import "./RootLayout.css";
import TopNavigation from "../../components/TopNavigation";
import { SidebarNavigation } from "../../components/SidebarNavigation";
import { KonnectLogo } from "../../components/icons";

interface RootLayoutProps {
  children: ReactNode;
  logoSrc?: string;
  logoComponent?: React.ReactNode;
  logoAlt?: string;
  notificationCount?: number;
  showCreateButton?: boolean;
  defaultSidebarCollapsed?: boolean;
  onCreateClick?: () => void;
  onCollapseClick?: () => void;
  onAppSwitcherClick?: () => void;
  onAIClick?: () => void;
  onNotificationsClick?: () => void;
  onHelpClick?: () => void;
  onSettingsClick?: () => void;
  onAvatarClick?: () => void;
  sidebarContent?: ReactNode;
  activeItem?: string;
  onSidebarItemClick?: (item: string) => void;
  searchPlaceholder?: string;
  onSearchChange?: (query: string) => void;
}

const RootLayout: React.FC<RootLayoutProps> = ({
  children,
  logoSrc,
  logoComponent = <KonnectLogo />,
  logoAlt = "Konnect xD",
  notificationCount = 0,
  showCreateButton = true,
  defaultSidebarCollapsed = false,
  onCreateClick,
  onCollapseClick,
  onAppSwitcherClick,
  onAIClick,
  onNotificationsClick,
  onHelpClick,
  onSettingsClick,
  onAvatarClick,
  sidebarContent,
  activeItem,
  onSidebarItemClick,
  searchPlaceholder,
  onSearchChange,
}) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(
    defaultSidebarCollapsed
  );

  const handleCollapseClick = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
    onCollapseClick?.();
  };

  return (
    <div className="root-layout">
      {/* Navigation Header */}
      <TopNavigation
        isSidebarCollapsed={isSidebarCollapsed}
        logoSrc={logoSrc}
        logoComponent={logoComponent}
        logoAlt={logoAlt}
        notificationCount={notificationCount}
        showCreateButton={showCreateButton}
        onCreateClick={onCreateClick}
        onCollapseClick={handleCollapseClick}
        onAppSwitcherClick={onAppSwitcherClick}
        onAIClick={onAIClick}
        onNotificationsClick={onNotificationsClick}
        onHelpClick={onHelpClick}
        onSettingsClick={onSettingsClick}
        onAvatarClick={onAvatarClick}
        searchPlaceholder={searchPlaceholder}
        onSearchChange={onSearchChange}
      />

      {/* Main Content */}
      <div className="root-layout-main-content">
        {/* Sidebar */}
        <div
          className={`sidebar-container ${isSidebarCollapsed ? "collapsed" : "expanded"}`}
        >
          <SidebarNavigation
            activeItem={activeItem}
            onItemClick={onSidebarItemClick}
          >
            {sidebarContent}
          </SidebarNavigation>
        </div>

        {/* Main Content Area */}
        <div
          className={`root-layout-content ${isSidebarCollapsed ? "sidebar-collapsed" : ""}`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default RootLayout;
export type { RootLayoutProps };
